import * as React from 'react';
import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import { DriveListState, FetchStatus } from '../DriveItemList/reducer';
import { DownloadManagerState } from '../DownloadManager/reducer';
import { DriveItemListOrigin } from './constants';
import DownloadsDriveItemListPage from './extends/Downloads';
import SelectionDriveItemListPage from './extends/Selection';
import FolderDriveItemListPage from './extends/Folder';
import NewDriveItemListPage from './extends/New';
import SearchDriveItemListPage from './extends/Search';
import AssortmentDriveItemListPage from './extends/Assortment';
import RoutesUtils from '../../utils/routes';
import UserAgentUtils from '../../utils/userAgent';
import Utils from '../../utils';
import DriveItemUtils from '../../utils/driveItem';
import { ListDisplayType } from '../DriveItemList/constants';

interface DriveItemListPageParams {
	origin: DriveItemListOrigin;
	originParam?: string;
	driveItemId?: string;
}

export interface DriveItemListPageProps {
	params: DriveItemListPageParams;
	driveList: DriveListState;
	downloadManager: DownloadManagerState;
	galleryId: number;
	showSearchField: boolean;
	isGalleryMetaFetched: boolean;
	displayType: ListDisplayType;
}

export class DriveItemListPage extends React.Component<DriveItemListPageProps, {}> {

	constructor(props: DriveItemListPageProps) {
		super(props);
		this.initializeView(props);
	}

	componentWillReceiveProps(nextProps: DriveItemListPageProps) {
		if (nextProps.params.origin !== this.props.params.origin) {
			this.initializeView(nextProps);
		}
	}

	render() {
		const { isGalleryMetaFetched } = this.props;
		let ResolvedDriveItemListPage = this.resolvedDriveItemListPage;
		if (ResolvedDriveItemListPage && isGalleryMetaFetched) {
			return (<ResolvedDriveItemListPage {...this.props} />);
		}
		return null;
	}

	get resolvedDriveItemListPage() {
		switch (this.props.params.origin) {
			case DriveItemListOrigin.Folder:
				return FolderDriveItemListPage;
			case DriveItemListOrigin.Selection:
				return SelectionDriveItemListPage;
			case DriveItemListOrigin.New:
				return NewDriveItemListPage;
			case DriveItemListOrigin.Search:
				return SearchDriveItemListPage;
			case DriveItemListOrigin.Assortment:
				return AssortmentDriveItemListPage;
			case DriveItemListOrigin.Downloads:
				return DownloadsDriveItemListPage;
		}
	}

	private initializeView(props: DriveItemListPageProps): void {
		for (let item in DriveItemListOrigin) {
			if (DriveItemListOrigin[item] === props.params.origin) {
				return;
			}
		}
		RoutesUtils.getPageNotFound();
	}
}

const mapStateToProps = (state: StoreState) => {
	const {
		driveList,
		downloadManager,
		routerParamsHistory,
		galleryInfos: {
			config: galleryConfig,
			config: {
				applicationGallery: galleryId,
			},
		},
	} = state;
	const isGalleryMetaFetched = UserAgentUtils.isMobileApp || Utils.isMaster(galleryConfig)
		? true
		: driveList.driveItemsFetchStatus[galleryId] && driveList.driveItemsFetchStatus[galleryId].metaFetchStatus === FetchStatus.FETCHED;
	const folderId = Utils.getCurrentFolderId(galleryId, routerParamsHistory);

	return {
		galleryId,
		driveList,
		downloadManager,
		isGalleryMetaFetched,
		displayType: DriveItemUtils.getDisplayType(driveList, routerParamsHistory, folderId),
	};
};

export default connect(mapStateToProps)(DriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/index.tsx